import axios from 'axios';

interface ApiResponse {
    data: any[];
    totalPage: number;
    totalResultat: number;
}

export function getSubscriberPrev(page, limit, sort, search): Promise<ApiResponse> {
    return axios.get(`/subscribers/prevoyance`, {
        params: {
            page,
            limit,
            sort,
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
    });
}

export function getSubscriberContractPrev(subscriberCod, page, limit, sort, search): Promise<ApiResponse> {
    return axios.get(`/subscribers/${subscriberCod}/contracts_prevoyance`, {
        params: {
            page,
            limit,
            sort,
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
    });
}
